var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTearOffcalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.07812,
    y: 3.58618,
    width: 27.8438,
    height: 25.9924,
    rx: 5.25,
    fill: "url(#paint0_linear_715_15146)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9219 10.3987H2.07812V8.68619C2.07812 5.86954 4.36145 3.58618 7.1781 3.58618H24.8219C27.6385 3.58618 29.9219 5.86954 29.9219 8.68619V10.3987Z",
    fill: "url(#paint1_linear_715_15146)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9219 10.3987H2.07812V8.68619C2.07812 5.86954 4.36145 3.58618 7.1781 3.58618H24.8219C27.6385 3.58618 29.9219 5.86954 29.9219 8.68619V10.3987Z",
    fill: "url(#paint2_linear_715_15146)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9219 10.3987H2.07812V8.68619C2.07812 5.86954 4.36145 3.58618 7.1781 3.58618H24.8219C27.6385 3.58618 29.9219 5.86954 29.9219 8.68619V10.3987Z",
    fill: "url(#paint3_radial_715_15146)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9219 10.3987H2.07812V8.68619C2.07812 5.86954 4.36145 3.58618 7.1781 3.58618H24.8219C27.6385 3.58618 29.9219 5.86954 29.9219 8.68619V10.3987Z",
    fill: "url(#paint4_linear_715_15146)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_715_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9215 20.2104V24.4786C29.9215 27.2952 27.6382 29.5786 24.8215 29.5786H20.4961L29.9215 20.2104Z",
    fill: "#D3CBDD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5625,
    y: 13.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5508,
    y: 13.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5391,
    y: 13.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5625,
    y: 18.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5625,
    y: 23.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5508,
    y: 18.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5508,
    y: 23.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5391,
    y: 18.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "url(#paint5_linear_715_15146)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dii_715_15146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5391,
    y: 23.2112,
    width: 2.80469,
    height: 2.80469,
    rx: 0.1,
    fill: "#9896A1"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_715_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8274 20.3879C29.888 20.3273 29.9221 20.2451 29.9221 20.1594C29.9221 19.9809 29.7774 19.8362 29.5989 19.8362H28.4297C23.8733 19.8362 20.1797 23.5298 20.1797 28.0862V29.2554C20.1797 29.4339 20.3244 29.5786 20.5029 29.5786C20.5886 29.5786 20.6708 29.5445 20.7314 29.4839L29.8274 20.3879Z",
    fill: "url(#paint6_radial_715_15146)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8274 20.3879C29.888 20.3273 29.9221 20.2451 29.9221 20.1594C29.9221 19.9809 29.7774 19.8362 29.5989 19.8362H28.4297C23.8733 19.8362 20.1797 23.5298 20.1797 28.0862V29.2554C20.1797 29.4339 20.3244 29.5786 20.5029 29.5786C20.5886 29.5786 20.6708 29.5445 20.7314 29.4839L29.8274 20.3879Z",
    fill: "url(#paint7_linear_715_15146)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_715_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9062 9.8772C28.9062 6.9777 27.6562 4.6272 23.6562 4.6272H13.5",
    stroke: "url(#paint8_radial_715_15146)",
    strokeWidth: 1.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_715_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01367 3.80029H9.51367V6.63563C9.51367 7.25544 9.01121 7.7579 8.3914 7.7579C7.80995 7.7579 7.32479 7.3138 7.27351 6.73462L7.01367 3.80029Z",
    fill: "url(#paint9_linear_715_15146)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_715_15146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1309 3.80029H22.6309V6.63563C22.6309 7.25544 22.1284 7.7579 21.5086 7.7579C20.9271 7.7579 20.442 7.3138 20.3907 6.73462L20.1309 3.80029Z",
    fill: "url(#paint10_linear_715_15146)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.15625,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint11_linear_715_15146)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.15625,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint12_radial_715_15146)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.15625,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint13_radial_715_15146)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2031,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint14_linear_715_15146)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2031,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint15_radial_715_15146)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2031,
    y: 1.64868,
    width: 2.5,
    height: 6.35938,
    rx: 1.25,
    fill: "url(#paint16_radial_715_15146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_715_15146",
    x: 1.07812,
    y: 2.58618,
    width: 29.8438,
    height: 26.9924,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.619608 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.788235 0 0 0 0 0.819608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15146",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.945098 0 0 0 0 0.976471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670588 0 0 0 0 0.619608 0 0 0 0 0.745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_715_15146",
    result: "effect4_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_715_15146",
    x: 19.4961,
    y: 19.6104,
    width: 10.8258,
    height: 9.96816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.917647 0 0 0 0 0.964706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: -0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658824 0 0 0 0 0.607843 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15146",
    result: "effect2_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dii_715_15146",
    x: 8.1625,
    y: 13.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_715_15146",
    x: 14.1508,
    y: 13.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_715_15146",
    x: 20.1391,
    y: 13.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dii_715_15146",
    x: 8.1625,
    y: 18.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dii_715_15146",
    x: 8.1625,
    y: 23.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dii_715_15146",
    x: 14.1508,
    y: 18.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dii_715_15146",
    x: 14.1508,
    y: 23.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dii_715_15146",
    x: 20.1391,
    y: 18.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.835294 0 0 0 0 0.917647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.631373 0 0 0 0 0.917647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.498039 0 0 0 0 0.819608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dii_715_15146",
    x: 20.1391,
    y: 23.0112,
    width: 3.40469,
    height: 3.40469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.752941 0 0 0 0 0.803922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_715_15146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.647059 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_715_15146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.572549 0 0 0 0 0.564706 0 0 0 0 0.607843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15146",
    result: "effect3_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_715_15146",
    x: 20.1797,
    y: 19.8362,
    width: 9.84219,
    height: 9.84243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.807843 0 0 0 0 0.870588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_715_15146",
    x: 12.25,
    y: 2.6272,
    width: 18.6562,
    height: 8.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_715_15146",
    x: 6.26367,
    y: 3.05029,
    width: 4,
    height: 5.45752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_15146"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_715_15146",
    x: 19.3809,
    y: 3.05029,
    width: 4,
    height: 5.45752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_15146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15146",
    x1: 5.17533,
    y1: 18.0861,
    x2: 28.0231,
    y2: 18.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_15146",
    x1: 1.75128,
    y1: 8.84762,
    x2: 27.8363,
    y2: 8.84762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4271C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794195,
    stopColor: "#4F9FDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_15146",
    x1: 16,
    y1: 3.58618,
    x2: 16,
    y2: 5.5022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5591D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5591D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7113 10.3987) rotate(-170.157) scale(19.9265 11.0778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.758836,
    stopColor: "#3E62C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B41A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_15146",
    x1: 21.175,
    y1: 11.2198,
    x2: 21.175,
    y2: 9.76001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437AC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_15146",
    x1: 23.6406,
    y1: 18.2112,
    x2: 19.9844,
    y2: 20.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C92DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B91DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0158 22.2737) rotate(45.6992) scale(3.40051 8.24079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_15146",
    x1: 25.1099,
    y1: 25.2853,
    x2: 24.8521,
    y2: 25.0275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.461334,
    stopColor: "#BFB8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D3E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9063 4.6272) rotate(152.761) scale(10.0874 14.5049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70C0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70C0F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_15146",
    x1: 8.14986,
    y1: 7.45412,
    x2: 7.67565,
    y2: -0.450247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#375DB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375DB2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_15146",
    x1: 21.267,
    y1: 7.45412,
    x2: 20.7928,
    y2: -0.450247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407FC8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_15146",
    x1: 10.6563,
    y1: 5.30047,
    x2: 8.15625,
    y2: 5.30047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931802,
    stopColor: "#A6A6A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.40625 8.00806) rotate(-90) scale(3.85045 3.56473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C88AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9AA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1853 3.80047) rotate(90) scale(2.85714 1.54195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99631,
    stopColor: "#BEBEC0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_15146",
    x1: 23.7031,
    y1: 5.30047,
    x2: 21.2031,
    y2: 5.30047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931802,
    stopColor: "#A6A6A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4531 8.00806) rotate(-90) scale(3.85045 3.56473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C88AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9AA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_15146",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2321 3.80047) rotate(90) scale(2.85714 1.54195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99631,
    stopColor: "#BEBEC0",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTearOffcalendar);
export default __webpack_public_path__ + "static/media/Tear-off calendar.cfbbc43a1d255a42757f15ec9b3d4c1c.svg";
export { ForwardRef as ReactComponent };